import React from 'react';
import styles from './Talk.module.scss';
import ReactPlayer  from 'react-player';

class Talk extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showPlayer: false,
    };
    this.togglePlayer = this.togglePlayer.bind(this);
  }

  togglePlayer() {
    this.setState({ showPlayer: !this.state.showPlayer });
  }

  render() {
    const { title, speaker, mp3_url } = this.props;
    const { showPlayer } = this.state;

    return (
      <div className={styles.talk}>
        <h3>{title}</h3>
        <div className={styles.speaker}>{speaker}</div>
        { showPlayer ?
          <div>
            <ReactPlayer
              url={mp3_url}
              controls
              playing
              height="50px"
              width="100%"
            />
          </div>
          :
          <div className={styles.listen} onClick={() => this.togglePlayer()}>
            Click to Listen
          </div>
        }
      </div>
    );
  }
}
export default Talk;
